import { Container, Row } from '@vfpf/vfpf-shared';
import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer>
      <Container>
        <Row>
          <div className="col-sm-auto">
            <ul className="nav flex-column flex-sm-row">
              <div className="col-lg-25">
                <li className="ssa-footer-title">
                  <small className="ssa-footer-body">
                    Meer informatie over Subsidie Sluitende Aanpak en het pre-advies vindt u op onze website:
                    <br />
                    <a href="https://www.vfpf.nl/subsidie-sluitende-aanpak" target="_blank">
                      {' '}
                      <u>vfpf.nl</u>{' '}
                    </a>
                  </small>
                </li>
              </div>
            </ul>
          </div>
          {/* TODO: move style to vfpf_prototype (need guidance!) */}
          <div className="col-lg text-lg-right" style={{ paddingTop: '0.75rem' }}>
            <a href="https://www.vfpf.nl/" target="_blank" rel="noreferrer">
              <span className="ssa-footer-copyright">&copy; Vervangingsfonds & Participatiefonds</span>
            </a>
          </div>
        </Row>
      </Container>
    </footer>
  );
};
